import { Outlet } from 'react-router-dom';

import { Wrapper } from '@american-autonomy/rantizo-ui';

import SiteFooter from 'components/SiteFooter';
import SiteHeader from 'components/SiteHeader';
import Toast from 'components/Toast';
import VersionAvailabilityBanner from 'components/VersionAvailabilityBanner';
import WithResponsive from 'components/WithResponsive';
import WideContentContainer from 'components/containers/WideContentContainer';

import useFeatureFlags from 'hooks/useFeatureFlags';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const WideLayout: FunctionComponent<Props> = ({ testId = TEST_ID }) => {
    const { V2_RESKIN } = useFeatureFlags();

    return (
        <>
            <div className={styles.wideLayout} data-testid={testId}>
                <div className={styles.headerSlot}>
                    <SiteHeader />
                </div>

                {V2_RESKIN ? (
                    <div className={styles.bannerSlot}>
                        <WithResponsive>
                            <VersionAvailabilityBanner />
                        </WithResponsive>
                    </div>
                ) : null}

                <Wrapper className={styles.wrapper}>
                    <WideContentContainer className={styles.wideContentContainer}>
                        <Outlet />
                    </WideContentContainer>

                    <SiteFooter className={styles.siteFooter} />
                </Wrapper>
            </div>

            <Toast />
        </>
    );
};

export default WideLayout;
